import React from 'react';
import { Link } from 'react-router-dom';
import '../../FishFinderBuilder.css';
import './CompareScreensV2.css';

function CompareScreensV2Landing() {
  return (
    <div className="compare-v2-page">
      <header className="compare-v2-hero">
        <h1>Find the Right Garmin Screen Fast</h1>
        <p className="compare-v2-lede">
          Get a recommendation or compare models side-by-side and see the best price instantly
        </p>
      </header>

      <div className="compare-v2-options">
        <Link to="/compare-screens-v2/choose" className="compare-v2-option">
          <h2>Help Me Choose</h2>
          <p>Answer a few quick questions to find the right Garmin screen</p>
          <span className="primary-cta-button">Start</span>
        </Link>

        <Link to="/compare-screens-v2/compare" className="compare-v2-option">
          <h2>Compare Screens</h2>
          <p>I already have a few models in mind</p>
          <span className="primary-cta-button">Compare Now</span>
        </Link>
      </div>
    </div>
  );
}

export default CompareScreensV2Landing;
